import { render, staticRenderFns } from "./prod.vue?vue&type=template&id=4cfcdecb&scoped=true&"
import script from "./prod.vue?vue&type=script&lang=js&"
export * from "./prod.vue?vue&type=script&lang=js&"
import style0 from "./prod.vue?vue&type=style&index=0&id=4cfcdecb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cfcdecb",
  null
  
)

export default component.exports